<template>
  <div class="container">
    <b-form @submit.prevent="login">
      <b-form-group id="input-group-1" label="账号:" label-for="account">
        <b-form-input id="account" v-model="form.account" type="text" required placeholder="输入账号"></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="密码:" label-for="password">
        <b-form-input
          id="password"
          v-model="form.password"
          type="password"
          required
          placeholder="输入密码"
        ></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary" v-if="!submitted">登陆</b-button>
      <b-spinner label="Spinning" v-else></b-spinner>
    </b-form>
  </div>
</template>


<script>
export default {
  data() {
    return {
      form: {
        account: "",
        password: ""
      },
      submitted: false
    };
  },
  methods: {
    login() {
      this.submitted = true;
      this.$store.dispatch("login", this.form).then(() => {
        this.$router.push({ name: "AdminHome" });
      });
    }
  },
};
</script>